<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap" *ngIf="isLoaded">
    <div class="app-l-main-heading">
        <h2 translate>menu.assessments</h2>
        <div class="app-l__actions-block">
            <button
                class="app-c-btn app-c-btn--primary-v2 app-c-btn--curve"
                (click)="showAssignModal('true')"
                translate>
                <img
                    alt=""
                    aria-hidden="true"
                    src="./assets/img/icons-svg/assign-user-icon.svg" />
                <span translate>clientList.assign</span>
            </button>
            <div class="app-c-select">
                <div class="app-c-custom-select" [class.is-open]="isDateRangeOpen">
                    <div class="app-c-select-trigger"
                        role="button"
                        tabindex="0"
                        [attr.aria-expanded]="isDateRangeOpen"
                        aria-haspopup="listbox"
                        [attr.aria-label]="(getSelectedDateRangeTitle() | translate) + ' - ' + ('clientList.dateRange' | translate)"
                        (click)="isDateRangeOpen = !isDateRangeOpen; $event.stopPropagation()"
                        (keydown.enter)="isDateRangeOpen = !isDateRangeOpen; $event.stopPropagation()"
                        (keydown.space)="isDateRangeOpen = !isDateRangeOpen; $event.preventDefault(); $event.stopPropagation()">
                    <img alt="" aria-hidden="true" src="./assets/img/icons-svg/calendarV1.svg" />
                    <span>{{ getSelectedDateRangeTitle() | translate }}</span>
                    </div>
                    <ul class="app-c-select-list" role="listbox" [attr.aria-label]="'clientList.dateRange' | translate" *ngIf="isDateRangeOpen" (click)="$event.stopPropagation()">
                    <li *ngFor="let days of dateRange"
                        role="option"
                        tabindex="0"
                        [attr.aria-selected]="dateRangeSelected === days.value"
                        [class.is-selected]="dateRangeSelected === days.value"
                        (click)="dateRangeSelected = days.value; isDateRangeOpen = false; onRangeChange(true)"
                        (keydown.enter)="dateRangeSelected = days.value; isDateRangeOpen = false; onRangeChange(true)">
                        {{ days.title | translate }}
                    </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="app-dm-das-assessment-list">
        <page-user-event-assign
            *ngIf="showEventAssignModal"
            [eventType]="'assessment'"
            [selectedUser]="userDetail"
            [disableUserList]="true"
            [disableEventList]="true"
            [cssClass]="'padding-none'"
            class="app-l-modecheck__sidepanel"
            [userList]="users"
            (closeModal)="onCloseOptions($event)"></page-user-event-assign>
        <div class="app-l-summary__base">
            <div class="app-l-result-summary">
                <div class="app-l-result__card-dm">
                    <div class="app-c-card__header">
                        <div class="title-section app-l-card__h-left">
                            <h2 class="initial-image" aria-hidden="true">
                                {{ getInitials(userDetail?.fullName) }}
                            </h2>
                            <h4>
                                {{ userDetail?.fullName }}<br />
                                <p>{{ userDetail?.email }}</p>
                            </h4>
                        </div>
                    </div>
                    <div class="demo-result-card">
                        <div class="demo-val">
                            <p translate>clientList.age</p>
                            <h4>
                                {{
                                    demographicData?.Age
                                        ? demographicData?.Age
                                        : '-'
                                }}
                            </h4>
                        </div>
                        <div class="demo-val">
                            <p translate>clientList.ethinicity</p>
                            <h4>
                                {{
                                    demographicData?.Ethnicity
                                        ? demographicData?.Ethnicity
                                        : '-'
                                }}
                            </h4>
                        </div>
                        <div class="demo-val">
                            <p translate>clientList.gender</p>
                            <h4>
                                {{
                                    demographicData?.Gender
                                        ? demographicData?.Gender
                                        : '-'
                                }}
                            </h4>
                        </div>
                        <div class="demo-val">
                            <p translate>clientList.gradLevel</p>
                            <h4>
                                {{
                                    demographicData?.GradeLevel
                                        ? demographicData?.GradeLevel
                                        : '-'
                                }}
                            </h4>
                        </div>
                        <div class="demo-val">
                            <p translate>clientList.referredBy</p>
                            <h4>
                                {{
                                    demographicData?.Referred
                                        ? demographicData?.Referred
                                        : '-'
                                }}
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="app-l-result__card-dm">
                    <div class="app-l-result__card-header">
                        <h3 class="app-c-heading--h3" translate>
                            clientList.snapshot
                        </h3>
                    </div>
                    <ng-container
                        *ngIf="!countDataLoaded"
                        [ngTemplateOutlet]="skeletonLoader"
                        [ngTemplateOutletContext]="{
                            height: '100%',
                        }">
                    </ng-container>
                    <div
                        class="app-l-result__card-body"
                        *ngIf="countDataLoaded">
                        <div class="app-l-completed-assessment">
                            <p translate>
                                clientList.assessment.completedAssessment
                            </p>
                            <h2>
                                {{
                                    countData?.assessment.mentalwellbeing.count
                                        ? countData?.assessment.mentalwellbeing
                                              .count
                                        : 0
                                }}
                                <span translate
                                    >dynamicAssessment.mentalwellbeing.title</span
                                >
                            </h2>
                        </div>
                        <div class="app-l-additional-assessment">
                            <p translate>
                                clientList.assessment.additionalAssessment
                            </p>
                            <div
                                class="additional-val"
                                *ngFor="
                                    let name of assessmentNames.slice(1);
                                    let i = index
                                ">
                                <ng-container *ngIf="name === 'DASS'">
                                    <p>
                                        {{ getCountByName(name)?.count || 0 }}
                                    </p>
                                    <p>{{ name }}</p>
                                    <div
                                        class="dass-levels"
                                        *ngIf="getCountByName(name)?.count > 0">
                                        <p>
                                            <span>Depression :</span>
                                            {{
                                                getCountByName(name)?.score
                                                    ?.DepressionScore?.level
                                            }},
                                        </p>
                                        <p>
                                            <span>Anxiety :</span>
                                            {{
                                                getCountByName(name)?.score
                                                    ?.AnxietyScore?.level
                                            }},
                                        </p>
                                        <p>
                                            <span>Stress :</span>
                                            {{
                                                getCountByName(name)?.score
                                                    ?.StressScore?.level
                                            }}
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="name != 'DASS'">
                                    <p>
                                        {{
                                            getCountByName(name)?.count
                                                ? getCountByName(name)?.count
                                                : 0
                                        }}
                                    </p>
                                    <p>{{ name }}</p>
                                    <p>
                                        {{
                                            getCountByName(name)?.count > 0
                                                ? getLevel(
                                                      name,
                                                      getCountByName(name)
                                                          ?.score
                                                  )
                                                : ''
                                        }}
                                    </p>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="app-l-result__card-dm"
                    *ngIf="
                        typeAssessment == 'mentalwellbeing' && myCurrentGoal
                    ">
                    <div class="current-goal-conatiner">
                        <div class="content-section" translate>
                            <div>
                                <h3 class="app-c-heading--h3" translate>
                                    dynamicAssessment.mentalwellbeing.myCurrentGoal
                                </h3>
                                <span
                                    class="recent-tabs-disclaimer"
                                    [translate]="myCurrentGoal"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="assessment-chart">
                    <div class="app-l-result__card">
                        <div class="app-l-result__card-header">
                            <div class="app-l-result__card-header-left">
                                <h3 class="app-c-heading--h3" translate>
                                    das.mentalWellBeingSummary
                                </h3>
                            </div>
                            <div
                                class="app-l-result__card-header-right"
                                *ngIf="assessmentListLoaded">
                                <div class="app-l-chart__legends">
                                    <button
                                        class="app-l-legend__stress"
                                        *ngIf="
                                            typeAssessment === 'mentalwellbeing'
                                        "
                                        [ngClass]="{
                                            actve:
                                                selectedChartLegend ===
                                                'mentalwellbeing',
                                        }"
                                        [attr.aria-pressed]="selectedChartLegend === 'mentalwellbeing'"
                                        (click)="
                                            selectLegend('mentalwellbeing')
                                        "
                                        translate>
                                        {{
                                            assessmentTranslation.mentalwellbeing
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ng-container
                            *ngIf="!assessmentListLoaded"
                            [ngTemplateOutlet]="skeletonLoader"
                            [ngTemplateOutletContext]="{
                                height: '100%',
                            }">
                        </ng-container>
                        <div
                            class="app-l-result__card-body"
                            *ngIf="assessmentListLoaded">
                            <div class="chart-container">
                                <canvas
                                    #dasAssessmentChart
                                    id="dasAssessmentChart"
                                    role="img"
                                    [attr.aria-label]="('das.mentalWellBeingSummary' | translate) + ' ' + ('clientList.chartDescription' | translate)"></canvas>
                            </div>
                        </div>
                        <div
                            class="app-l-assessment-results"
                            *ngIf="assessmentListLoaded">
                            <div class="title-section">
                                <h3 translate>
                                    clientList.assessment.recentHighScore
                                </h3>
                                <a
                                    class="action-view"
                                    [routerLink]="[
                                        '/app/assessment/mentalwellbeing/listing/' +
                                            id,
                                    ]"
                                    [queryParams]="{
                                        prevpage: 'clientlist',
                                    }"
                                    translate
                                    >clientList.viewAll</a
                                >
                            </div>
                            <div class="app-l-result__card">
                                <div
                                    class="app-l-result-item__base"
                                    *ngIf="
                                        assessments?.length !== 0 && !tooLarge
                                    "
                                    role="list">
                                    <div
                                        class="app-l-result-item__card-block"
                                        role="listitem"
                                        *ngFor="
                                            let assessment of assessments
                                                | paginate
                                                    : {
                                                          itemsPerPage:
                                                              itemsPerPage,
                                                          currentPage:
                                                              currentPage,
                                                          totalItems:
                                                              totalCount,
                                                      };
                                            let i = index
                                        ">
                                        <div
                                            class="app-l-result-item__card-header">
                                            <div class="app-l-result-item__hl">
                                                <div
                                                    class="app-l-result-item__icon">
                                                    <svg-icon
                                                        icon="calendar1"
                                                        aria-hidden="true"
                                                        class="w-100 h-100"></svg-icon>
                                                </div>
                                                <h3
                                                    class="app-c-body-text--14-m">
                                                    {{
                                                        assessment.created
                                                            | date: 'MM-dd-yyyy'
                                                    }}
                                                </h3>
                                                <span
                                                    class="app-l-result-item__time">
                                                    ({{
                                                        assessment.created
                                                            | date: 'h:mm a'
                                                    }})
                                                </span>
                                                <!-- <span class="app-l-result-item__badge">
                                                    Very High
                                                </span> -->
                                            </div>
                                        </div>
                                        <div
                                            class="app-l-result-item__card-body">
                                            <div
                                                class="app-l-rs__item-base"
                                                *ngIf="
                                                    typeAssessment ===
                                                    'mentalwellbeing'
                                                ">
                                                <div
                                                    class="app-l-rs__item-block">
                                                    <h6
                                                        class="app-l-rs__title"
                                                        translate>
                                                        clientList.assessment.mentalWellBeing
                                                    </h6>
                                                    <div class="score-level">
                                                        <p
                                                            *ngIf="
                                                                typeAssessment ==
                                                                'mentalwellbeing'
                                                            ">
                                                            {{
                                                                'dynamicAssessment.score'
                                                                    | translate
                                                            }}{{
                                                                getMetricScore(
                                                                    assessment
                                                                )
                                                            }}
                                                        </p>
                                                        <p
                                                            *ngIf="
                                                                typeAssessment ==
                                                                'mentalwellbeing'
                                                            "
                                                            class="strong"
                                                            translate>
                                                            |
                                                        </p>
                                                        <p
                                                            class="app-l-rs__status">
                                                            {{
                                                                getLevel(
                                                                    assessment.type,
                                                                    assessment.metricScore
                                                                )
                                                            }}
                                                        </p>
                                                    </div>
                                                    <ng-container
                                                        [ngTemplateOutlet]="
                                                            daslevelIndicationImg
                                                        "
                                                        [ngTemplateOutletContext]="{
                                                            level: assessmentService.getAssessmentScoreLevel(
                                                                assessment.type,
                                                                assessment.metricScore
                                                            ),
                                                        }">
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="app-l-result-item__base"
                                    *ngIf="
                                        assessments?.length === 0 && !tooLarge
                                    ">
                                    <p translate>clientList.noData</p>
                                </div>
                                <div
                                    class="app-l-result-item__base"
                                    *ngIf="tooLarge">
                                    <p translate>clientList.tooLarge</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="app-l-assessment-results-percentage">
                <div class="app-l-result__card">
                    <div class="title-section">
                        <h3 translate>
                            clientList.assessment.mentalWellBeingAssessments
                        </h3>
                        <a
                            *ngIf="dassScoreProgressLoaded"
                            translate
                            class="action-view"
                            [routerLink]="[
                                '/app/assessment/mentalwellbeing/listing/' + id,
                            ]"
                            [queryParams]="{
                                prevpage: 'clientlist',
                            }"
                            >clientList.viewAll</a
                        >
                    </div>
                    <ng-container
                        *ngIf="!dassScoreProgressLoaded"
                        [ngTemplateOutlet]="skeletonLoader"
                        [ngTemplateOutletContext]="{
                            height: '100%',
                        }">
                    </ng-container>
                    <div
                        class="app-l-result__card-body-ms-rc"
                        *ngIf="dassScoreProgressLoaded">
                        <div class="app-l-result-item__base">
                            <div class="app-l-result-item__card-block">
                                <div class="title-section">
                                    <h4 translate>
                                        clientList.assessment.mostRecentMentalWellbeing
                                    </h4>
                                    <a
                                        *ngIf="
                                            assessmentMostRecent?.MetricScore
                                        "
                                        translate=""
                                        class="action-view"
                                        [attr.aria-label]="'clientList.assessment.mostRecentMentalWellbeing' | translate"
                                        [routerLink]="[
                                            '/app/assessment/result',
                                            assessmentMostRecent?.ID,
                                            'mentalwellbeing',
                                            id,
                                        ]"
                                        [queryParams]="{
                                            prevpage: 'clientlist',
                                        }"
                                        ><svg-icon
                                            icon="right-nav-arrow"
                                            aria-hidden="true"
                                            class="w-100 h-100"></svg-icon
                                    ></a>
                                </div>
                                <div class="app-l-result-item__card-body">
                                    <div
                                        class="app-l-rs__item-base app-l-da__item-base">
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                clientList.assessment.mentalWellBeing
                                            </h6>
                                            <h3 class="app-l-rs__status">
                                                {{
                                                    getLevel(
                                                        typeAssessment,
                                                        assessmentMostRecent?.MetricScore
                                                    )
                                                }}
                                            </h3>
                                            <ng-container
                                                *ngIf="
                                                    assessmentMostRecent?.MetricScore >
                                                    0
                                                "
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessmentService.getAssessmentScoreLevel(
                                                        typeAssessment,
                                                        assessmentMostRecent?.MetricScore
                                                    ),
                                                }">
                                            </ng-container>
                                            <h3 class="app-l-rs__count">
                                                {{
                                                    assessmentMostRecent?.MetricScore
                                                        ? (assessmentMostRecent?.MetricScore
                                                          | number: '1.0-0')
                                                        : 0
                                                }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="app-l-result-item__base">
                            <div class="app-l-result-item__card-block">
                                <div class="title-section">
                                    <h4 translate>
                                        clientList.assessment.initialMentalWellbeing
                                    </h4>
                                    <a
                                        *ngIf="assessmentInitial?.MetricScore"
                                        translate=""
                                        class="action-view"
                                        [attr.aria-label]="'clientList.assessment.initialMentalWellbeing' | translate"
                                        [routerLink]="[
                                            '/app/assessment/result',
                                            assessmentInitial?.ID,
                                            'mentalwellbeing',
                                            id,
                                        ]"
                                        [queryParams]="{
                                            prevpage: 'clientlist',
                                        }"
                                        ><svg-icon
                                            icon="right-nav-arrow"
                                            aria-hidden="true"
                                            class="w-100 h-100"></svg-icon
                                    ></a>
                                </div>

                                <div class="app-l-result-item__card-body">
                                    <div
                                        class="app-l-rs__item-base app-l-da__item-base">
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                clientList.assessment.mentalWellBeing
                                            </h6>
                                            <h3 class="app-l-rs__status">
                                                {{
                                                    getLevel(
                                                        typeAssessment,
                                                        assessmentInitial?.MetricScore
                                                    )
                                                }}
                                            </h3>
                                            <ng-container
                                                *ngIf="
                                                    assessmentInitial?.MetricScore >
                                                    0
                                                "
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessmentService.getAssessmentScoreLevel(
                                                        typeAssessment,
                                                        assessmentInitial?.MetricScore
                                                    ),
                                                }">
                                            </ng-container>
                                            <h3 class="app-l-rs__count">
                                                {{
                                                    assessmentInitial?.MetricScore
                                                        ? (assessmentInitial?.MetricScore
                                                          | number: '1.0-0')
                                                        : 0
                                                }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="app-l-result__card-body app-l-mr__item-base">
                        <div class="app-l-result-item__base">
                            <div class="app-l-result-item__card-block">
                                <div class="title-section">
                                    <h4 translate>
                                        clientList.assessment.mostRecent
                                    </h4>
                                </div>

                                <div class="app-l-result-item__card-body">
                                    <div class="app-l-rs__item-base">
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                clientList.assessment.mentalWellBeing
                                            </h6>
                                            <div class="card-result-ms">
                                                <p>
                                                    {{
                                                        Math.abs(
                                                            mentalWellBeingDifference
                                                        )
                                                    }}
                                                </p>
                                                <div
                                                    class="card-ms-status-right">
                                                    <p>
                                                        <svg-icon
                                                            aria-hidden="true"
                                                            [icon]="
                                                                +assessmentMostRecent?.MetricScore >
                                                                +assessmentInitial?.MetricScore
                                                                    ? 'improved'
                                                                    : 'declined'
                                                            "></svg-icon>
                                                        <span class="sr-only">
                                                            {{
                                                                +assessmentMostRecent?.MetricScore >
                                                                +assessmentInitial?.MetricScore
                                                                    ? ('clientList.assessment.improved' | translate)
                                                                    : ('clientList.assessment.declined' | translate)
                                                            }}
                                                        </span>
                                                        {{
                                                            mentalWellBeingChange !=
                                                            'Infinity'
                                                                ? Math.round(
                                                                      Math.abs(
                                                                          mentalWellBeingChange
                                                                      )
                                                                  ) + '%'
                                                                : '100%'
                                                        }}
                                                    </p>
                                                    <div
                                                        class="card-ms-status"
                                                        [ngClass]="
                                                            +assessmentMostRecent?.MetricScore >
                                                            +assessmentInitial?.MetricScore
                                                                ? 'improved'
                                                                : 'declined'
                                                        ">
                                                        {{
                                                            +assessmentMostRecent?.MetricScore >
                                                            +assessmentInitial?.MetricScore
                                                                ? 'Improved'
                                                                : 'Declined'
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="app-l-result__card app-l-assessment-assignments">
                    <div class="app-l-result__card-header">
                        <div class="app-l-result__card-header-left">
                            <h3 class="app-c-heading--h3" translate>
                                clientList.assessment.assessmentAssignments
                            </h3>
                        </div>
                        <div
                            class="app-l-result__card-header-right"
                            *ngIf="assignedListLoaded">
                            <button
                                class="app-c-btn app-c-btn--primary-v2 app-c-btn--curve"
                                (click)="showAssignModal('true')"
                                translate>
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="./assets/img/icons-svg/assign-user-icon.svg" />
                                <span translate>clientList.assign</span>
                            </button>
                        </div>
                    </div>
                    <div class="app-l-result__card-body">
                        <div class="app-l-result-item__base">
                            <div class="app-l-result-item__card-block">
                                <ng-container
                                    *ngIf="!assignedListLoaded"
                                    [ngTemplateOutlet]="skeletonLoader"
                                    [ngTemplateOutletContext]="{
                                        height: '100px',
                                    }">
                                </ng-container>
                                <my-tabs
                                    *ngIf="assignedListLoaded"
                                    #tabGroup
                                    (focusChange)="onTabChanged($event)">
                                    <my-tab>
                                        <ng-template #myTabTitle>
                                            <div translate>
                                                clientList.assigned
                                            </div>
                                        </ng-template>
                                        <div
                                            class="app-l-assignment-ls-container"
                                            *ngIf="
                                                showAssigned &&
                                                assignedList.length != 0
                                            "
                                            role="list"
                                            [attr.aria-label]="'clientList.assigned' | translate">
                                            <div
                                                class="app-l-assignment-ls"
                                                role="listitem"
                                                *ngFor="
                                                    let assigned of assignedList
                                                ">
                                                <div>
                                                    <!-- <span
                                                        *ngIf="
                                                            assigned.Type ===
                                                                'assessment';
                                                            else otherType
                                                        "
                                                        translate>
                                                        {{ 'DASS ' }}
                                                    </span> -->
                                                    <span translate>
                                                        {{
                                                            assigned.Name
                                                        }}</span
                                                    >
                                                </div>
                                                <ng-template #otherType>
                                                    <span translate>
                                                        {{
                                                            assigned.Type + ' '
                                                        }}
                                                    </span>
                                                </ng-template>
                                                <!-- <div translate>
                                                    clientList.createdOn
                                                </div> -->
                                                <div translate>
                                                    <div class="icon">
                                                        <svg-icon
                                                            icon="time"
                                                            aria-hidden="true"></svg-icon>
                                                    </div>
                                                    <span class="sr-only" translate>clientList.createdOn</span>
                                                    {{
                                                        assigned.Date
                                                            | date: 'longDate'
                                                    }}
                                                </div>
                                                <div>
                                                    <button
                                                        tabindex="0"
                                                        class="app-c-btn app-c-btn--icon-primary app-c-btn--icon app-c-btn--icon-20"
                                                        type="button"
                                                        [attr.aria-label]="('clientList.delete' | translate) + ' ' + assigned.Name"
                                                        (click)="
                                                            deleteAssign(
                                                                assigned.ID
                                                            )
                                                        "
                                                        (keypress)="
                                                            deleteAssign(
                                                                assigned.ID
                                                            )
                                                        ">
                                                        <svg-icon
                                                            icon="trash"
                                                            class="w-100 h-100"
                                                            aria-hidden="true"
                                                            alt="trash"></svg-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="app-l-assignment-ls-container"
                                            *ngIf="
                                                showAssigned &&
                                                assignedList.length == '0'
                                            ">
                                            <div class="app-l-assignment-ls">
                                                <div>
                                                    <h3
                                                        translate
                                                        class="nodata-title">
                                                        clientList.noData
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </my-tab>
                                    <my-tab>
                                        <ng-template #myTabTitle>
                                            <span translate
                                                >clientList.completed</span
                                            >
                                        </ng-template>
                                        <div
                                            class="app-l-assignment-ls-container"
                                            *ngIf="
                                                showCompleted &&
                                                completedList.length != 0
                                            "
                                            role="list"
                                            [attr.aria-label]="'clientList.completed' | translate">
                                            <div
                                                class="app-l-assignment-ls"
                                                role="listitem"
                                                *ngFor="
                                                    let completed of completedList
                                                ">
                                                <div>
                                                    <!-- <span
                                                        *ngIf="
                                                            completed.Type ===
                                                                'assessment';
                                                            else otherType
                                                        "
                                                        translate>
                                                        {{ 'DASS ' }}
                                                    </span> -->
                                                    <span translate>
                                                        {{
                                                            completed.Name
                                                        }}</span
                                                    >
                                                </div>
                                                <ng-template #otherType>
                                                    <div translate>
                                                        <span>{{
                                                            completed.Type + ' '
                                                        }}</span>
                                                        clientList.assessment.title
                                                    </div>
                                                </ng-template>
                                                <div translate>
                                                    <div class="icon">
                                                        <svg-icon
                                                            icon="time"
                                                            aria-hidden="true"></svg-icon>
                                                    </div>
                                                    <span class="sr-only" translate>clientList.completedOn</span>
                                                    {{
                                                        completed.UpdatedOnUtc
                                                            | date: 'longDate'
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="app-l-assignment-ls-container"
                                            *ngIf="
                                                showCompleted &&
                                                completedList.length == 0
                                            ">
                                            <div class="app-l-assignment-ls">
                                                <div>
                                                    <h3
                                                        translate
                                                        class="nodata-title">
                                                        clientList.noData
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </my-tab>
                                </my-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template let-level="level" #daslevelIndicationImg>
    <div
        [ngClass]="
            ['resilience', 'mentalwellbeing'].includes(typeAssessment)
                ? 'app-c-welltrack__progress app-c-welltrack__progress-medium resilience-very-high'
                : 'app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__very-high'
        "
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'clientList.assessment.veryHigh' | translate"
        *ngIf="level == 4">
        <div class="app-c-welltrack__progress-fill" style="width: 100%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__high"
        role="progressbar"
        aria-valuenow="80"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'clientList.assessment.high' | translate"
        *ngIf="level == 3">
        <div class="app-c-welltrack__progress-fill" style="width: 80%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__moderate"
        role="progressbar"
        aria-valuenow="60"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'clientList.assessment.moderate' | translate"
        *ngIf="level == 2">
        <div class="app-c-welltrack__progress-fill" style="width: 60%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__mild"
        role="progressbar"
        aria-valuenow="40"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'clientList.assessment.mild' | translate"
        *ngIf="level == 1">
        <div class="app-c-welltrack__progress-fill" style="width: 40%"></div>
    </div>
    <div
        [ngClass]="
            ['resilience', 'mentalwellbeing'].includes(typeAssessment)
                ? 'app-c-welltrack__progress app-c-welltrack__progress-medium resilience-good'
                : 'app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__good'
        "
        role="progressbar"
        aria-valuenow="20"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'clientList.assessment.good' | translate"
        *ngIf="level == 0">
        <div class="app-c-welltrack__progress-fill" style="width: 20%"></div>
    </div>
</ng-template>

<ng-template let-height="height" #skeletonLoader>
    <div class="app-c-card" role="status" [attr.aria-label]="'clientList.loading' | translate">
        <img alt="" aria-hidden="true" src="/assets/img/loader.gif" class="loader-gif-xs" />
    </div>
</ng-template>